module.exports = __webpack_public_path__ + "img/1.913e2f3d.gif";